import EcoImg from 'eco-design/base/eco-img';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import { useLang } from '@/i18n';

export default function Screen7() {
    const { t } = useLang('theProductV2.Screen7');
    const webpOrJpg = useWebpOrJpg('#rapid-mag-Screen7-V2');

    return (
        <section
            className={`${css.comp}  GtmModuleData-section`}
            id="rapid-mag-Screen7-V2"
            data-section-id={'rapid-mag-Screen7-V2'}
            data-section-title={t('title')}
        >
            <div className="label">{t('label')}</div>
            <div className="title">{t('title')}</div>
            <div className="desc">{t('desc')}</div>
            <div className="img-box">
                <EcoImg
                    pc={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1762851708962/Screen7.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1762851709239/Screen7.webp',
                    )}
                    h5={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1762851708414/Screen7-m.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1762851708647/Screen7-m.webp',
                    )}
                />
            </div>
            <div className="tips">{t('tips')}</div>
        </section>
    );
}
